import React, { useEffect, useState } from 'react'
import "./Testmonials.css"

const Testmonials = () => {

  const peoples = [
    {
      id: 1,
      image: "five-stars-rating-button-yellow-rating-stars-on-white-background-free-vector.jpg",
      name: "Krishna Rao ",
      quote:
        "I consulted Dr. Siva Srikar for my mother left leg fracture. He clearly explained about the surgery. Surgery went smoothly and my mother’s leg pain and movement improved as expected. Overall I am very satisfied and would rate him 5/5 for orthopedic surgery care.",
    },
    {
      id: 2,
      image: "five-stars-rating-button-yellow-rating-stars-on-white-background-free-vector.jpg",
      name: "kodamala sarath ",
      quote: "Dr. Siva Srikar garu chala baga treatment chesaru. He performed the surgery excellently. We are extremely happy and satisfied, and we were discharged in good health. Thank you so much, doctor garu.",
    },
    {
      id: 3,
      image: "five-stars-rating-button-yellow-rating-stars-on-white-background-free-vector.jpg",
      name: "Lavu Kalyani",
      quote:"Ma relatives ki sir surgery chesaru vallu recommend chesthe mem kuda knee issue undhi ani vellam ..reports Anni chusi naku meniscus injury undhi annaru ...surgery chesaru sir .ipudu pain lekunda walking chesthunna .thanks to srikar garu.",
    },
    {
      id: 4,
      image: "five-stars-rating-button-yellow-rating-stars-on-white-background-free-vector.jpg",
      name: "janu anu",
      quote:
        "My wife had a serious accident, and she suffered a very severe injury. Many doctors told us that the surgery would be extremely difficult and that she might not be able to walk again. However, Dr. Siva Srikar garu performed the surgery successfully. Today, we are very happy and feel like we have been given a new life.",
    },
    // {
    //   id:5 ,
    //   image: "five-stars-rating-button-yellow-rating-stars-on-white-background-free-vector.jpg",
    //   name: "apple moulalia",
    //   quote:"I ADMIT SHRI HOSPITAL UNDER DR. KALYAN CHAKRAVARHTY KANDULA GASTROENTEROLOGY. SIR TREATMENT WELL AND GOOD, NICE HOSPITAL, ONE OF THE BEST HOSPITAL, THANK YOU TO DR. KALYAN CHAKRAVARHTY SIR 🙏🙏"
    // },
  ];

  const [people] = useState(peoples);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const lastIndex = people.length - 1;
    if (index < 0) {
      setIndex(lastIndex);
    }
    if (index > lastIndex) {
      setIndex(0);
    }
  }, [index, people]);

  useEffect(() => {
    let slider = setInterval(() => {
      setIndex(index + 1);
    }, 5000);
    return () => {
      clearInterval(slider);
    };
  }, [index]);
  return (
    <>

      <section className="section">
        <div className="section-content">
          <div className="section-center">
            {people.map((item, indexPeople) => (
              <article key={item.id} className={indexPeople === index ? 'activeSlide' : 'nextSlide'}>
                <p className="text" style={{textAlign:'justify'}}>{item.quote}</p>
                <div className="person-info">
                  <img src={item.image} alt={item.name} className="person-img" />
                  <h4>{item.name}</h4>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}

export default Testmonials